.container {
    align-items: center;
    display: flex;
    flex-direction: column;
}

.image {
    max-width: 100%;
}
